import { StepCard } from "./StepCard";
import { ReactComponent as Step01Icon } from "./icons/step1.svg";
import { ReactComponent as Step02Icon } from "./icons/step2.svg";
import { ReactComponent as Step03Icon } from "./icons/step3.svg";
import { ReactComponent as ArrowIcon } from "./icons/arrow-right.svg";
import { Typography } from "@mui/material";

export default function StepSection() {
  return (
    <section className="bg-slate-100 py-16">
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        sx={(theme) => ({
          color: theme.palette.primary.main, // #143282
          mb: 5,
        })}
      >
        商品検索ステップ
      </Typography>

      <div className="flex justify-center gap-8">
        <StepCard
          step="01"
          title="ニーズを入力"
          description="検索欄に探したい商品を入力してください。"
          icon={<Step01Icon width={98} height={98} />}
        />
        <div className="flex items-center">
          <ArrowIcon className="w-6 h-6" />
        </div>
        <StepCard
          step="02"
          title="AIと会話"
          description="AIの質問に答えるだけで条件が絞り込まれます。"
          icon={<Step02Icon width={98} height={98} />}
        />
        <div className="flex items-center">
          <ArrowIcon className="w-6 h-6" />
        </div>
        <StepCard
          step="03"
          title="商品を比較"
          description="AIが条件に合う商品をランキングで提案します。"
          icon={<Step03Icon width={98} height={98} />}
        />
      </div>
    </section>
  );
}
